export default "__VITE_ASSET__xk5Td_iY__"